import type {StateCreator} from 'zustand'
import type {FilesRoutePayloadUser} from '../../page-data/payloads/files'

export interface CurrentUserSlice {
  currentUser: FilesRoutePayloadUser
  currentUserActions: {
    updateCurrentUser: (user: Partial<FilesRoutePayloadUser>) => void
  }
}

export interface CurrentUserSliceOpts {
  currentUser: FilesRoutePayloadUser
}

export const createCurrentUserSlice =
  ({
    currentUser,
  }: CurrentUserSliceOpts): StateCreator<CurrentUserSlice, [['zustand/devtools', never]], [], CurrentUserSlice> =>
  set => ({
    currentUser,
    currentUserActions: {
      updateCurrentUser: (updatedUser: Partial<FilesRoutePayloadUser>) => {
        set(state => ({
          currentUser: {
            ...state.currentUser,
            ...updatedUser,
          },
        }))
      },
    },
  })
